<template>
  <div class="rate">
    <div v-for="(_,i) in starNums" @mouseenter="moveChange(i)" @mouseleave="leaveChange(i)" @click="handleClick(i)"
          :class="['rate-icon', {active:picked >= i}]">
      <span></span>
	  </div>
    <span class="rate-text">{{ evaluation }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      picked: 0,
      clickPicked: -1,
      stop: false
    }
  },
  props: {
    starNums: {
      type: Number,
      default: 5,
    },
    evaluationList: {
      type: Array,
      default: function () {
        return ['很差', '比较差', '一般', '还不错', '很好'];
      },
    },
    starIndex: {
      type: Number,
      default: 0,
      required: true
    }
  },
  computed: {
    evaluation() {
      return this.evaluationList[this.picked] || '';
    }
  },
  methods: {
    moveChange(i) {
      this.picked = i;
    },
    leaveChange(i) {
      if (this.clickPicked !== -1) {
        this.picked = this.clickPicked;
        return;
      }
      this.picked = -1;
    },
    handleClick(i) {
      this.clickPicked = i;
    }
  },
  created() {
    this.picked = this.starIndex;
  }
}
</script>

<style scoped>
.rate {
  display: flex;
  align-items: center;
  height: 30px;
}
.rate-icon {
  cursor: pointer;
  display: inline-block;
  width: 40px;
  height: 18px;
}
.rate-icon>span {
  display: inline-block;
  height: 18px;
  width: 20px;
  background: url("~@/assets/imgs/stars.png") -28px 0px no-repeat;
}
.rate-icon.active>span {
  background-position: 0px 0px;
}
.rate-text {
  color: #ffa02f;
  font-size: 14px;
  line-height: 30px;
  margin-left: 10px;
}
</style>